import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListContentComponent } from './list-content.component';

@NgModule({
  declarations: [ListContentComponent],
  imports: [CommonModule],
  exports: [ListContentComponent],
})

export class ListContentModule {}
